export const Icons = {
  loadingIcon: () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='20'
        height='20'
        viewBox='0 -960 960 960'
      >
        <path
          fill='#fff'
          d='M480-80q-82 0-155-31.5t-127.5-86Q143-252 111.5-325T80-480q0-83 31.5-155.5t86-127Q252-817 325-848.5T480-880q17 0 28.5 11.5T520-840q0 17-11.5 28.5T480-800q-133 0-226.5 93.5T160-480q0 133 93.5 226.5T480-160q133 0 226.5-93.5T800-480q0-17 11.5-28.5T840-520q17 0 28.5 11.5T880-480q0 82-31.5 155t-86 127.5q-54.5 54.5-127 86T480-80z'
        />
      </svg>
    );
  },
  emailIcon: () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='19'
        height='20'
        fill='none'
        viewBox='0 0 19 20'
      >
        <path
          stroke='#939393'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M15.734 4.063H3.266c-.82 0-1.485.664-1.485 1.484v8.906c0 .82.665 1.485 1.485 1.485h12.468c.82 0 1.485-.665 1.485-1.485V5.547c0-.82-.665-1.484-1.485-1.484z'
        />
        <path
          stroke='#939393'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M4.156 6.438L9.5 10.593l5.344-4.156'
        />
      </svg>
    );
  },
  passwordIcon: () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='19'
        height='20'
        fill='none'
        viewBox='0 0 19 20'
      >
        <path
          stroke='#939393'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M5.938 7.031V5.844A3.563 3.563 0 019.5 2.28v0a3.563 3.563 0 013.563 3.563V7.03m-10.094 0a.594.594 0 00-.594.594v8.016c0 1.122.956 2.078 2.078 2.078h10.094c1.122 0 2.078-.91 2.078-2.032V7.625a.594.594 0 00-.594-.594H2.97z'
        />
      </svg>
    );
  },
  nameIcon: () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='19'
        height='20'
        fill='none'
        viewBox='0 0 19 20'
      >
        <path
          stroke='#939393'
          strokeLinecap='round'
          strokeLinejoin='round'
          d='M12.884 5.692c-.151 2.034-1.693 3.693-3.385 3.693-1.692 0-3.237-1.659-3.385-3.693C5.961 3.577 7.461 2 9.5 2s3.538 1.615 3.385 3.692z'
        />
        <path
          stroke='#939393'
          strokeMiterlimit='10'
          d='M9.5 11.846c-3.346 0-6.742 1.846-7.37 5.33-.077.42.161.824.601.824H16.27c.44 0 .677-.404.601-.823-.628-3.485-4.025-5.331-7.37-5.331z'
        />
      </svg>
    );
  },
  couponIcon: () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='21'
        height='16'
        fill='none'
        viewBox='0 0 21 16'
      >
        <mask
          id='mask0_291_396'
          style={{
            maskType: "luminance" 
          }}
          width='21'
          height='16'
          x='0'
          y='0'
          maskUnits='userSpaceOnUse'
        >
          <path fill='#fff' d='M20.5.488H.5v15.024h20V.488z' />
        </mask>
        <g mask='url(#mask0_291_396)'>
          <path
            fill='#111'
            d='M18.4 15.488H2.58a2.062 2.062 0 01-2.082-2.081V9.826h.833c.999 0 1.79-.833 1.79-1.832 0-1-.791-1.79-1.79-1.832H.498v-3.58C.498 1.416 1.414.5 2.58.5H18.4c1.166 0 2.082.916 2.082 2.082v3.58h-.832c-1 0-1.832.833-1.832 1.832 0 1 .833 1.832 1.832 1.832h.832v3.58a2.062 2.062 0 01-2.081 2.082zM2.164 11.367v2.04c0 .208.209.416.417.416H18.4a.448.448 0 00.416-.416v-2.04c-1.498-.375-2.664-1.75-2.664-3.373a3.477 3.477 0 012.665-3.372v-2.04a.448.448 0 00-.417-.417H2.58a.448.448 0 00-.417.417v2.04a3.486 3.486 0 012.623 3.372 3.485 3.485 0 01-2.623 3.373z'
          />
        </g>
      </svg>
    );
  },
  checkIcon: () => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width='21'
        height='18'
        fill='none'
        viewBox='0 0 21 18'
      >
        <path
          fill='#093047'
          d='M.924 8.256l5.988 3.316L20.155.521l-12.568 17L.924 8.256z'
        />
      </svg>
    );
  },
  EmailIcon: ({
    width, height
  }) => {
    return <EmailIcon
      width={width}
      height={height}
    />
  },
  InsIcon: ({
    width, height
  }) => {
    return <InsIcon
      
      
      width={width}
      height={height} />
  },
  FacebookIcon: ({
    width, height
  }) => {
    return <FacebookIcon width={width}
      height={height} />
  },
  XIcon: ({
    width, height
  }) => {
    return <XIcon width={width}
      height={height} />
  },
  YoutubeIcon: ({
    width, height
  }) => {
    return <YoutubeIcon width={width}
      height={height} />
  },
  PinIcon: ({
    width, height
  }) => {
    return <PinIcon width={width}
      height={height} />
  },
  TikTokIcon: ({
    width, height
  }) => {
    return <TikTokIcon width={width}
      height={height} />
  },
  SMSIcon: ({
    width, height
  }) => {
    return <SMSIcon width={width}
      height={height} />
  },
  closeIcon: ({
    size 
  }) => {
    return (
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        fill='none'
        viewBox='0 0 12 12'
      >
        <path
          stroke='#111'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.5'
          d='M11 11L1 1m10 0L1 11'
        />
      </svg>
    );
  }
}


export function EmailIcon({
  width = 35, height = 35
}) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 35 35'
    >
      <path fill='url(#pattern0_9350_47977)' d='M0 0H35V35H0z' />
      <defs>
        <pattern
          id='pattern0_9350_47977'
          width='1'
          height='1'
          patternContentUnits='objectBoundingBox'
        >
          <use transform='scale(.005)' xlinkHref='#image0_9350_47977' />
        </pattern>
        <image
          id='image0_9350_47977'
          width='200'
          height='200'
          xlinkHref='/icons/icon_1.png'
        />
      </defs>
    </svg>
  );
}

export function InsIcon({
  width = 35, height = 35
}) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 35 35'
    >
      <path fill='url(#pattern0_9350_47975)' d='M0 0H35V35H0z' />
      <defs>
        <pattern
          id='pattern0_9350_47975'
          width='1'
          height='1'
          patternContentUnits='objectBoundingBox'
        >
          <use transform='scale(.0006)' xlinkHref='#image0_9350_47975' />
        </pattern>
        <image
          id='image0_9350_47975'
          width='1673'
          height='1673'
          xlinkHref='/icons/icon_2.png'
        />
      </defs>
    </svg>
  );
}

export function FacebookIcon({
  width = 35, height = 35
}) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 35 35'
    >
      <path fill='url(#pattern0_9350_47976)' d='M0 0H35V34.979H0z' />
      <defs>
        <pattern
          id='pattern0_9350_47976'
          width='1'
          height='1'
          patternContentUnits='objectBoundingBox'
        >
          <use transform='scale(.0006)' xlinkHref='#image0_9350_47976' />
        </pattern>
        <image
          id='image0_9350_47976'
          width='1674'
          height='1673'
          xlinkHref='/icons/icon_3.png'
        />
      </defs>
    </svg>
  );
}

export function XIcon({
  width = 35, height = 35
}) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 35 35'
    >
      <path fill='url(#pattern0_9350_47978)' d='M0 0H35V35H0z' />
      <defs>
        <pattern
          id='pattern0_9350_47978'
          width='1'
          height='1'
          patternContentUnits='objectBoundingBox'
        >
          <use transform='scale(.0006)' xlinkHref='#image0_9350_47978' />
        </pattern>
        <image
          id='image0_9350_47978'
          width='1673'
          height='1673'
          xlinkHref='/icons/icon_4.png'
        />
      </defs>
    </svg>
  );
}

export function YoutubeIcon({
  width = 35, height = 35
}) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 36 35'
    >
      <path fill='url(#pattern0_9350_47979)' d='M0 0H35.021V35H0z' />
      <defs>
        <pattern
          id='pattern0_9350_47979'
          width='1'
          height='1'
          patternContentUnits='objectBoundingBox'
        >
          <use transform='scale(.0006)' xlinkHref='#image0_9350_47979' />
        </pattern>
        <image
          id='image0_9350_47979'
          width='1674'
          height='1673'
          xlinkHref='/icons/icon_5.png'
        />
      </defs>
    </svg>
  );
}

export function PinIcon({
  width = 35, height = 35
}) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 36 36'
    >
      <path
        fill='url(#pattern0_9350_47980)'
        d='M0.021 0H35.021V35.021H0.021z'
      />
      <defs>
        <pattern
          id='pattern0_9350_47980'
          width='1'
          height='1'
          patternContentUnits='objectBoundingBox'
        >
          <use transform='scale(.0006)' xlinkHref='#image0_9350_47980' />
        </pattern>
        <image
          id='image0_9350_47980'
          width='1673'
          height='1674'
          xlinkHref='/icons/icon_6.png'
        />
      </defs>
    </svg>
  );
}

export function TikTokIcon({
  width = 35, height = 35
}) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 36 35'
    >
      <path
        fill='url(#pattern0_9350_47981)'
        d='M0.021 0H35.021V35H0.021z'
      />
      <defs>
        <pattern
          id='pattern0_9350_47981'
          width='1'
          height='1'
          patternContentUnits='objectBoundingBox'
        >
          <use transform='scale(.0006)' xlinkHref='#image0_9350_47981' />
        </pattern>
        <image
          id='image0_9350_47981'
          width='1673'
          height='1673'
          xlinkHref='/icons/icon_7.png'
        />
      </defs>
    </svg>
  );
}

export function SMSIcon({
  width = 35, height = 35
}) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
      width={width}
      height={height}
      fill='none'
      viewBox='0 0 36 35'
    >
      <path
        fill='url(#pattern0_9351_47982)'
        d='M0.021 0H35.021V35H0.021z'
      />
      <defs>
        <pattern
          id='pattern0_9351_47982'
          width='1'
          height='1'
          patternContentUnits='objectBoundingBox'
        >
          <use transform='scale(.00637)' xlinkHref='#image0_9351_47982' />
        </pattern>
        <image
          id='image0_9351_47982'
          width='157'
          height='157'
          xlinkHref='/icons/icon_8.png'
        />
      </defs>
    </svg>
  );
}
